module.exports = __webpack_public_path__ + "static/pic03-d1ee8f494885a5252d501ff1b54bd046.jpg";